export default __webpack_public_path__ + "static/media/diagram-with-star.b29daea7.svg";